import advanceNotice from './advance-notice.vue'
export default advanceNotice
